'use client';

import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  height: 65vh;
`;

export const Subtitle = styled.p`
  text-align: center;
  color: #4b5563;
  font-size: 1.25rem;
  line-height: 1.8;
  margin: 0;
  font-weight: 400;
  letter-spacing: -0.01em;

  margin-bottom: 24px;
`;
